"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelEventHandlersEventHandlerActivator = exports.CancelEventHandlersEventHandlerArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EventHandlerType_1 = require("../EventHandlerType");
class CancelEventHandlersEventHandlerArgs {
    constructor(eventHandlerIds) {
        this.eventHandlerIds = eventHandlerIds;
        this.__type = EventHandlerType_1.EventHandlerType.CancelEventHandlers;
        this.__typeName = "CancelEventHandlers";
    }
}
exports.CancelEventHandlersEventHandlerArgs = CancelEventHandlersEventHandlerArgs;
let CancelEventHandlersEventHandlerActivator = class CancelEventHandlersEventHandlerActivator {
    activate(sequence, container, handler) {
        for (const eventHandlerId of handler.args.eventHandlerIds) {
            container.cancelEventHandler(eventHandlerId);
        }
    }
};
CancelEventHandlersEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.CancelEventHandlers)
], CancelEventHandlersEventHandlerActivator);
exports.CancelEventHandlersEventHandlerActivator = CancelEventHandlersEventHandlerActivator;
